import { AxiosInstance } from 'axios';

export function setAxiosAuthorization(axiosInstance: AxiosInstance, token: string) {
  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
}

export function removeAxiosAuthorization(axiosInstance: AxiosInstance) {
  delete axiosInstance.defaults.headers.Authorization;
}
